var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "step-sect" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row justify-content-center" }, [
          _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "step_list" }, [
              _c("div", { staticClass: "step_item" }, [
                _c("div", { staticClass: "success-item success" }),
                _vm._v(" "),
                _c("p", { staticClass: "min-min" }, [_vm._v("Jämför")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "step_item" }, [
                _c("div", { staticClass: "success-item" }),
                _vm._v(" "),
                _c("p", { staticClass: "min-min" }, [_vm._v("Byt")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "step_item" }, [
                _c("div", { staticClass: "success-item grey" }),
                _vm._v(" "),
                _c("p", { staticClass: "min-min" }, [_vm._v("Klart")])
              ])
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }